/**
 * Site header.
 */



/**
 * Module imports.
 */
import { ErrorHandler } from 'errorhandler/errorhandler.js';



/**
 * Module constants
 */
export const MOBILE_MENU_UPPER_BREAKPOINT  = 1240;
export const DESKTOP_MENU_LOWER_BREAKPOINT = 1241;



/**
 * Class for the main header.
 */
export class Header
{
	/**
	 * Determines if we're showing the mobile menu instead of the desktop menu.
	 *
	 * @return     {boolean}  True if mobile menu is active, false otherwise.
	 */
	static isMobileMenu()
	{
		try
		{
			return (
				MOBILE_MENU_UPPER_BREAKPOINT >= $( window ).width()
					? true
					: false
			);
		}
		catch( err )
		{
			Header.error( 'isMobileMenu', err );

			// Return false for consistent return
			return false;
		}
	}



	/**
	 * Determines if we're showing the desktop menu instead of the mobile menu.
	 *
	 * @return     {boolean}  True if desktop menu is active, false otherwise.
	 */
	static isDesktopMenu()
	{
		try
		{
			// Check if we're below the breakpoint
			return (
				DESKTOP_MENU_LOWER_BREAKPOINT <= $( window ).width()
				? true
				: false
			);
		}
		catch( err )
		{
			Header.error( 'isDesktopMenu', err );

			// Return false for consistent return
			return false;
		}
	}



	/**
	 * Handles generic errors thrown by the class.
	 *
	 * @param      {string}  functionName  The function name where the error occured
	 * @param      {string}  errorMessage  The error message the error generated
	 */
	static error( functionName, errorMessage )
	{
		// Run it through the main error function
		ErrorHandler.error( 'Header', functionName, errorMessage );
	}



	/**
	 * Class constructor.
	 */
	constructor()
	{
		// Member variables
		this.$collapseHandler          = false;
		this.$menu                     = false;
		this.$menuItem                 = false;
		this.collapseHandlerTimeout    = false;
		this.hasAlternativeColorScheme = false;
		this.hasUniformColorScheme     = false;
		this.isFrontPage               = false;
		this.scrolled                  = false;
	}



	/**
	 * Adds the necessary event listeners.
	 */
	addListeners()
	{
		let _this = this;

		// Wait for DOMContentLoaded
		$( document ).ready(
			() =>
			{
				const $body       = $( 'body' );
				const $header     = $( '.header' );
				const $navigation = $( '.navigation' );

				// Check if it's the frontpage
				if ( $body.hasClass( 'home' ) )
				{
					// Set a member variable for that
					this.isFrontPage = true;
				}

				// Check if we're using alternate color schemes
				if ( $body.hasClass( 'document--has-alternative-header-color-scheme' ) )
				{
					// Set a member variable for that
					this.hasAlternativeColorScheme = true;
				}

				// Check if we're using a uniform color schemes
				if ( $body.hasClass( 'document--has-uniform-header-color-scheme' ) )
				{
					// Set a member variable for that
					this.hasUniformColorScheme = true;
				}

				// Set menu element to member variable
				this.$menu = $( '.header .nav-list' );

				// Handle initial state for window event based functions
				this.handleMobileOnlyARIAAttributes();
				this.collapseNavbarOnScroll();

				// Listen for clicks on the show/hide mobile menu button
				$( '#nav-toggle' ).on(
					'click',
					() =>
					{
						// Toggle the mobile menu
						this.toggleMobileMenu();
					}
				);

				// Listen for clicks on submenu toggle buttons, although that's not what we REALLY want. HOWEVER, due to it being a button it acts more as a kind of button-scoped "submit" handler, allowing us to capture spacebar, enter, and other types of non-mouse input related to A11Y without having to check for specific keypress events or other input. One ring to rule them all...)
				$( '.header .submenu-toggler' ).on(
					'click',
					( evt ) =>
					{
						// Toggle visibility of the related submenu
						this.toggleSubmenuVisibility( $( evt.currentTarget ) );
					}
				);

				// Listen for keypresses on links in menu
				$( '.header .menu-item a' ).on(
					'keypress',
					( evt ) =>
					{
						// Toggle visibility of the related submenu
						this.goToLinkOnSpecificInput( evt );
					}
				);

				// Set A11Y state when hovering
				$( '.header .menu-item.menu-item-has-children[aria-expanded]' ).on(
					'mouseenter',
					( evt ) =>
					{
						// Set the element that we entered
						this.$menuItem = $( evt.currentTarget );

						// Open the menu
						this.setSubmenuA11YState( true, evt );
					}
				);

				// Set A11Y state when mouse leaves menu
				$( '.header .menu-item.menu-item-has-children[aria-expanded]' ).on(
					'mouseleave',
					function( evt )
					{
						// Set the element that we exited
						_this.$menuItem = $( this );

						// Close the menu
						_this.setSubmenuA11YState( false, evt );
					}
				);

				// Handle hovering of the submenu collapse fixer
				$( '.header .submenu-collapse-fixer' ).on(
					'mouseenter',
					( evt ) =>
					{
						// Set the element that we hovered
						this.$collapseHandler = $( evt.currentTarget );

						// Handle closing of the menu
						this.handleSubmenuCollapse( evt );
					}
				);

				// Listen for scroll events
				$( window ).scroll(
					() =>
					{
						// Collapse navbar if necessary
						this.collapseNavbarOnScroll();
					}
				);

				// Listen for window resize
				$( window ).on(
					'resize',
					() =>
					{
						// Handle ARIA attributes that are only relevant for mobile
						this.handleMobileOnlyARIAAttributes();
					}
				);
			}
		);
	}



	/**
	 * Collapse the navbar on scroll.
	 */
	collapseNavbarOnScroll()
	{
		// Element references
		const $header     = $( '.header' );
		const $mainMenu   = $( '.main-menu' );
		const $navigation = $( '.navigation' );

		// If we're on top and we've scrolled down on the page
		if ( false === this.scrolled && 10 < $( window ).scrollTop() )
		{
			// Indicate that we HAVE scrolled
			this.scrolled = true;

			$header.addClass( 'header--scrolled' );
			$mainMenu.addClass( 'main-menu--scrolled' );
			$navigation.addClass( 'navigation--scrolled' );
		}
		// If we have actually scrolled down before but are back on top
		else if ( true === this.scrolled && 0 >= $( window ).scrollTop() )
		{
			// Indicate that we HAVEN'T scrolled
			this.scrolled = false;

			$header.removeClass( 'header--scrolled' );
			$mainMenu.removeClass( 'main-menu--scrolled' );
			$navigation.removeClass( 'navigation--scrolled' );
		}
	}



	/**
	 * Toggles visibility of the mobile menu.
	 */
	toggleMobileMenu()
	{
		// Reference self
		const _this = this;

		// Element references
		const $navigation   = $( '.navigation' );
		const $toggleButton = $( '#nav-toggle' );

		// Is header open?
		if ( $navigation.hasClass( 'navigation--open' ) )
		{
			// Remove class from the main HTML element so we can scroll again
			$( 'html' ).removeClass( 'document--mobile-menu-open' );

			// Remove the class from all elements signifying it's open
			$navigation.removeClass( 'navigation--open' );

			// Set pressed status to false
			$toggleButton.attr( 'aria-pressed', 'false' );
		}
		// Not open
		else
		{
			// Add a class to the main HTML element so we can avoid duplicate scrollbars and such
			$( 'html' ).addClass( 'document--mobile-menu-open' );

			// Add a class to all elements signifying it's open
			$navigation.addClass( 'navigation--open' );

			// Set pressed status to false
			$toggleButton.attr( 'aria-pressed', 'true' );

			_this.workaroundOldIEBugs();
		}
	}



	/**
	 * Toggles visibility of the first submenu found after the clicked button.
	 *
	 * @param      {object}  $clickedButton  jQuery object for the clicked
	 *                                       button
	 */
	toggleSubmenuVisibility( $clickedButton )
	{
		// Reference self
		let _this = this;

		// Element references
		_this.$menuItem = $clickedButton.closest( '.menu-item' );

		// If the button is pressed since before (submenu open)
		if ( true === $clickedButton.attr( 'aria-pressed' ) || 'true' === $clickedButton.attr( 'aria-pressed' ) )
		{
			_this.setSubmenuA11YState( false );
		}
		else
		{
			_this.setSubmenuA11YState( true );
		}
	}



	/**
	 * Sets the necessary A11Y states related to a submenu.
	 *
	 * @param      {string}  state   The state
	 */
	setSubmenuA11YState( state = 'true', evt = false )
	{
		try
		{
			// Reference self
			let _this = this;

			// Make sure we have a menu item
			if ( null === _this.$menuItem || 0 >= _this.$menuItem.length )
			{
				throw 'You need to specify a menu item before attempting to set its A11Y state.';
			}

			// Only set state if criteria is met. This makes sure menu items are only affected if they have A11Y attributes since before and allows us to have hover effects on desktop and click effects in the mobile menu.
			if
			(
				// Menu item should have an A11Y state to begin with
				_this.$menuItem.get( 0 ).hasAttribute( 'aria-expanded' )
				&&
				(
					// We're in desktop mode
					true === Header.isDesktopMenu()
					||
					// Or if it wasn't a hover event
					(
						typeof evt.type === 'undefined'
						||
						(
							'mouseenter' !== evt.type
							&&
							'mouseleave' !== evt.type
						)
					)
				)
			)
			{
				// Convert to string for maximum consistency
				state = state.toString();

				// Set "pressed" state for toggle button
				_this.$menuItem.children( '.submenu-toggler' ).first().attr( 'aria-pressed', state );

				// Set "expanded" state for menu item
				_this.$menuItem.attr( 'aria-expanded', state );

				// If we're closing the submenu
				if ( 'false' === state )
				{
					// Close ALL submenus below this one
					_this.$menuItem.find( '.menu-item.menu-item-has-children[aria-expanded]' ).each(
						function()
						{
							$( this ).attr( 'aria-expanded', state );
						}
					);

					// Set ALL buttons below this one as unpressed
					_this.$menuItem.find( '.submenu-toggler' ).each(
						function()
						{
							$( this ).attr( 'aria-pressed', state );
						}
					);
				}
				// Opening the menu
				else
				{
					// Loop siblings
					_this.$menuItem.siblings().each(
						function()
						{
							// Overwrite menuItem (kinda fugly way to do this, but JS without React/Angular just isn't worth the time to run properly OOP)
							_this.$menuItem = $( this );

							// Close all other menus
							_this.setSubmenuA11YState( false );
						}
					);
				}
			}
		}
		catch( err )
		{
			Header.error( 'setSubmenuA11YState', err );
		}
	}



	/**
	 * Handles collapsing submenus more gracefully.
	 *
	 * @param {*} evt 
	 */
	handleSubmenuCollapse( evt )
	{
		try
		{
			// Reference self
			let _this = this;

			// Clear any previous timeouts
			clearTimeout( _this.$collapseHandlerTimeout );

			// Wait a bit
			_this.$collapseHandlerTimeout = setTimeout(
				function()
				{
					// Hide the element
					_this.$collapseHandler.css( 'display', 'none' );

					// Wait a bit
					setTimeout(
						function()
						{
							// Unhide the element
							_this.$collapseHandler.css( 'display', '' );
						},
						50
					);
				},
				2000
			)
		}
		catch( err )
		{
			Header.error( 'handleSubmenuCollapse', err );
		}
	}



	/**
	 * Go to the currently focused link on certain types of A11Y related input.
	 *
	 * @param      {object}  evt     The event object
	 */
	goToLinkOnSpecificInput( evt )
	{
		try
		{
			// Was that spacebar?
			if ( 32 === evt.keyCode )
			{
				// Stop browser from scrolling down, that just gets confusing
				evt.preventDefault();

				// Click the link
				evt.currentTarget.click();
			}
		}
		catch( err )
		{
			Header.error( 'goToLinkOnSpecificInput', err );
		}
	}



	/**
	 * Handles the ARIA attributes for the meun that only are relevant in mobile
	 * mode.
	 *
	 * While removing the attribute instead of adding it would be more
	 * mobile-first, we're doing it the opposite way here. The reason for that
	 * is that the desktop menu works without JS, while the mobile menu does
	 * not. Therefore we get better total compatibility by doing it this way, so
	 * don't go changing this later just to be trendy with 'mobile-first' and
	 * all that.
	 */
	handleMobileOnlyARIAAttributes()
	{
		try
		{
			// Functionality
			let itemAction = false;

			// Make sure we've set the menu element
			if ( false === this.$menu )
			{
				throw 'No menu element specified.';
			}

			// Are we in mobile menu mode but haven't applied the relevant ARIA attributes?
			if
			(
				true === Header.isMobileMenu()
				&&
				'false' === this.$menu.attr( 'data-mobileariaapplied' ).toString()
			)
			{
				// Mark it as applied so we don't run necessary operations on the following resize events (until we come to desktop size again)
				this.$menu.attr( 'data-mobileariaapplied', 'true' );

				// Set item action to apply attributes
				itemAction = 'apply';
			}
			// Are we in desktop menu mode and have applied the relevant ARIA attributes?
			else if
			(
				true === Header.isDesktopMenu()
				&&
				'true' === this.$menu.attr( 'data-mobileariaapplied' ).toString()
			)
			{
				// Mark it as NOT applied so we don't run necessary operations on the following resize events (until we come to mobile size again)
				this.$menu.attr( 'data-mobileariaapplied', 'false' );

				// Set item action to remove attributes
				itemAction = 'remove';
			}


			// Does it seem like we need to do anything?
			if ( false !== itemAction )
			{
				// Loop all sub menu items with attributes for mobile only ARIA
				this.$menu.find( '.menu-item[data-mobilearia]' ).each(
					function()
					{
						// Element references
						let $menuItem = $( this );

						// Get attributes to change
						let attributes = JSON.parse( $menuItem.attr( 'data-mobilearia' ) );

						// Loop attributes
						for ( let attribute in attributes )
						{
							// Did we want to apply the attributes?
							if ( 'apply' === itemAction )
							{
								$menuItem.attr(
									attribute,
									attributes[ attribute ]
								);
							}
							// Nope, then remove them instead
							else
							{
								$menuItem.removeAttr( attribute );
							}
						}

						// If we're applying attrbiutes
						if ( 'apply' === itemAction )
						{
							// Also enable the toggler button
							$menuItem.children( '.submenu-toggler' ).first().removeAttr( 'aria-hidden' );
						}
						// Removing attributes
						else
						{
							// Also disable the toggler button
							$menuItem.children( '.submenu-toggler' ).first().attr( 'aria-hidden', 'true' );
						}
					}
				);
			}
		}
		catch( err )
		{
			Header.error( 'handleMobileOnlyARIAAttributes', err );
		}
	}



	/**
	 * Work around old IE. As always.
	 */
	workaroundOldIEBugs()
	{
		try
		{
			// Reference self
			let _this = this;

			// Are we using Internet Explorer and are we in mobile menu mode? 'cause if we're not then it doesn't matter
			if ( 'internet-explorer' === window.app.BrowserDetection.browserInfo.slug && true === Header.isMobileMenu() )
			{
				// Element references
				let firstLevelLinks = _this.$menu.children( '.menu-item' ).children( 'a' );

				// Loop links
				firstLevelLinks.each(
					function()
					{
						// Element references
						let $link = $( this );

						// Set margin to 0
						$link.css( 'margin-left', '0' );

						// Wait a bit...
						setTimeout(
							function()
							{
								// Reset margin and let the CSS handle it
								$link.css( 'margin-left', '' );
							},
							100
						);

					}
				);
			}
		}
		catch( err )
		{
			Header.error( 'workaroundOldIEBugs', err );
		}
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/modules/header/header.js